module.exports = __webpack_public_path__ + "static/media/truckcoin_red.98015b84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/truckcoin_red.svg
// module id = 899
// module chunks = 0